import { useEffect, useState } from 'react'

import {
  useSubsidyOrdersSettingsStatus,
  useSubsidyOrdersSettingsApply,
} from 'app/dataProviders/org/subsidyOrdersSettingsApply/hooks'

import PlainButton from 'app/common/ui-next/plain-button'
import { OrgId } from 'app/common/types/id'
import PlainConfirmModal from 'app/common/ui-next/plain-confirm-modal'

export const SubsidyOrdersSettingsApplyButton = ({
  orgId,
  allowance,
  orderType,
}: {
  orgId: OrgId
  allowance: string
  orderType: 'cafeteria' | 'compensation'
}) => {
  const [confirm, setConfirm] = useState(false)

  const {
    data: { running },
    loading,
    request: requestStatus,
  } = useSubsidyOrdersSettingsStatus({ params: { id: orgId }, autoload: false })

  const [pending, setPending] = useState(false)

  const apply = useSubsidyOrdersSettingsApply({
    params: { id: orgId, allowance, orderType },
  })

  const isApplyDisabled = pending || running || loading

  const handleApply = async () => {
    setConfirm(false)
    setPending(true)
    const res = await apply()
    if (res) {
      await requestStatus()
    }
    setPending(false)
  }

  useEffect(() => {
    requestStatus()
  }, [])

  return (
    <>
      <PlainButton disabled={isApplyDisabled} onClick={() => setConfirm(true)}>
        {running && !loading ? 'Применяется к текущим справкам…' : 'Применить к текущим справкам'}
      </PlainButton>

      {confirm && (
        <PlainConfirmModal
          messageText={`Вы уверены? Применить к текущим справкам?`}
          cancelButtonTitle="Отмена"
          confirmButtonTitle="Да"
          onCancel={() => setConfirm(false)}
          onConfirm={handleApply}
        />
      )}
    </>
  )
}
